import {
  languageBuilder
} from "./builder.js";
const anime_airing = {
  UNIT_SINGULAR: `acara`,
  UNIT_PLURAL: `acara`,
  UNIT_SHORT: `Acara`,
  SUBUNIT_SINGULAR: `episode`,
  SUBUNIT_PLURAL: `episode`,
  SUBUNIT_SHORT: `Ep.`,
  SUBUNIT_VERB_FUTURE: `akan tayang`,
  SUBUNIT_VERB_PAST: `tayang`
};
const anime_bluray = {
  UNIT_SINGULAR: `acara`,
  UNIT_PLURAL: `acara`,
  UNIT_SHORT: `Acara`,
  SUBUNIT_SINGULAR: `volume`,
  SUBUNIT_PLURAL: `volume`,
  SUBUNIT_SHORT: `Vol.`,
  SUBUNIT_VERB_FUTURE: `akan diterbitkan`,
  SUBUNIT_VERB_PAST: `terbit`
};
const manga_chapter = {
  UNIT_SINGULAR: `manga`,
  UNIT_PLURAL: `manga`,
  UNIT_SHORT: `Manga`,
  SUBUNIT_SINGULAR: `chapter`,
  SUBUNIT_PLURAL: `chapter`,
  SUBUNIT_SHORT: `Ch.`,
  SUBUNIT_VERB_FUTURE: `akan diterbitkan`,
  SUBUNIT_VERB_PAST: `terbit`
};
const manga_volume = {
  UNIT_SINGULAR: `manga`,
  UNIT_PLURAL: `manga`,
  UNIT_SHORT: `Manga`,
  SUBUNIT_SINGULAR: `volume`,
  SUBUNIT_PLURAL: `volume`,
  SUBUNIT_SHORT: `Vol.`,
  SUBUNIT_VERB_FUTURE: `akan diterbitkan`,
  SUBUNIT_VERB_PAST: `terbit`
};
const strings = {
  ALL_COMPLETE: `Semua proyek sudah selesai!`,
  CONNECTION_ERROR: `Hubungan bermasalah`,
  CONFIG_HEADER: `Konfigurasi`,
  WEBSITE_SETTINGS_HEADER: `Pengaturan situs`,
  APP_URL: `URL aplikasi`,
  LINK_PAGE: `Buka halaman`,
  PAGE_BGCOLOR: `Warna latar belakang halaman`,
  NO_COLOR: `Abaikan warna latar`,
  RECOMMENDED_BGCOLOR: `Rekomendasi warna latar`,
  OVERRIDE_BGCOLOR: `Override recommendation`,
  THEME_HEADER: `Pilihan Tema`,
  THEME_LIGHT: `Terang`,
  THEME_DARK: `Gelap`,
  SIZE_HEADER: `Pilihan Ukuran`,
  SIZE_SMALL: `Kecil (tidak dianjurkan)`,
  SIZE_NORMAL: `Reguler`,
  ACCENT_HEADER: `Warna aksen`,
  ACCENT_RED: `Merah`,
  ACCENT_YELLOW: `Kuning`,
  ACCENT_GREEN: `Hijau`,
  ACCENT_BLUE: `Biru`,
  ACCENT_INDIGO: `Indigo`,
  ACCENT_PURPLE: `Nila`,
  ACCENT_PINK: `Merah muda`,
  ACCENT_NONE: `Tanpa aksen`,
  LANGUAGE_HEADER: `Bahasa`,
  EMBED_HEADER: `Kode Embed untuk Wordpress`,
  EMBED_DESCRIPTION: `Ubah ukuran iframe setelah pemuatan halaman`,
  EMBED_SHOW: `Tunjukkan kode embed`,
  EMBED_HIDE: `Sembunyikan kode embed`,
  ALL_POSITIONS: `Semua Posisi Staf`,
  EXAMPLE_ERROR: `Ini adalah contoh kesalahan`,
  EXAMPLE_STATUS: `Ini adalah pesan status opsional`,
  UNIT_JOINT_WITH: `Bersama dengan {0}`,
  UNIT_SHOW_LESS: `Sembunyikan`,
  UNIT_SHOW_LESS_PLURAL: void 0,
  UNIT_SHOW_REMAINDER_SINGULAR: `Tunjukkan {1} %SUBUNIT_SINGULAR%...`,
  UNIT_SHOW_REMAINDER_PLURAL: `Tunjukkan {1} %SUBUNIT_PLURAL%...`,
  UNIT_UPDATED: `Diperbarui {2}`,
  SUBUNIT_NOT_PUBLISHED: `%SUBUNIT_SHORT% {0} %SUBUNIT_VERB_FUTURE% {1}`,
  SUBUNIT_WAS_PUBLISHED: `%SUBUNIT_SHORT% {0} %SUBUNIT_VERB_PAST% {1}`,
  SUBUNIT_TO_RELEASE: `%SUBUNIT_SHORT% {0} menunggu rilis`,
  SUBUNIT_IN_PROGRESS: `%SUBUNIT_SHORT% {0} menunggu {2}`,
  SUBUNIT_NO_PROGRESS: `(belum ada kemajuan)`
};
import id from "../../_snowpack/pkg/javascript-time-ago/locale/id.json.proxy.js";
const lang = {
  locale: id,
  strings
};
export default {
  anime_airing: languageBuilder(lang, anime_airing),
  anime_bluray: languageBuilder(lang, anime_bluray),
  manga_chapter: languageBuilder(lang, manga_chapter),
  manga_volume: languageBuilder(lang, manga_volume)
};
//# sourceMappingURL=id.js.map
